import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { useCapabilities } from "store/capability-hooks";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectIsStudentPreview, selectQueryString } from "store/selectors";
import { viewStateActions } from "store/slices/view";
import { Link } from "utils/routing";

export const StudentPreview = () => {
  const dispatch = useAppDispatch();

  const queryString = useAppSelector(selectQueryString);
  const { canAuthorSection } = useCapabilities();
  const isStudentPreview = useAppSelector(selectIsStudentPreview);

  return (
    <>
      {isStudentPreview && (
        <Button
          className="-ml-2 text-black"
          eventName="Account settings - Stop preview as a student"
          kind="helpCenter"
          onClick={() => dispatch(viewStateActions.setIsStudentPreview(false))}
        >
          {t("profile_panel.stop_student_preview")}
        </Button>
      )}

      {!isStudentPreview && canAuthorSection && (
        <Button
          as={Link}
          className="w-full justify-start text-black-tint-20 hover:text-black-tint-20"
          eventName="Account settings - Preview as a student"
          kind="helpCenter"
          to={{ pathname: ".", search: `?${queryString}&student=1` }}
          onClick={() => dispatch(viewStateActions.setIsStudentPreview(true))}
        >
          {t("section.sidebar.planner.preview_as_student")}
        </Button>
      )}
    </>
  );
};
